import landscape1_600 from "./landscape1-600.webp";
import landscape1_900 from "./landscape1-900.webp";
import landscape1 from "./landscape1.webp";
import landscape10_600 from "./landscape10-600.webp";
import landscape10_900 from "./landscape10-900.webp";
import landscape10 from "./landscape10.webp";
import landscape11_600 from "./landscape11-600.webp";
import landscape11_900 from "./landscape11-900.webp";
import landscape11 from "./landscape11.webp";
import landscape12_600 from "./landscape12-600.webp";
import landscape12_900 from "./landscape12-900.webp";
import landscape12 from "./landscape12.webp";
import landscape2_600 from "./landscape2-600.webp";
import landscape2_900 from "./landscape2-900.webp";
import landscape2 from "./landscape2.webp";
import landscape3_600 from "./landscape3-600.webp";
import landscape3_900 from "./landscape3-900.webp";
import landscape3 from "./landscape3.webp";
import landscape4_600 from "./landscape4-600.webp";
import landscape4_900 from "./landscape4-900.webp";
import landscape4 from "./landscape4.webp";
import landscape5_600 from "./landscape5-600.webp";
import landscape5_900 from "./landscape5-900.webp";
import landscape5 from "./landscape5.webp";
import landscape6_600 from "./landscape6-600.webp";
import landscape6_900 from "./landscape6-900.webp";
import landscape6 from "./landscape6.webp";
import landscape7_600 from "./landscape7-600.webp";
import landscape7_900 from "./landscape7-900.webp";
import landscape7 from "./landscape7.webp";
import landscape8_600 from "./landscape8-600.webp";
import landscape8_900 from "./landscape8-900.webp";
import landscape8 from "./landscape8.webp";
import landscape9_600 from "./landscape9-600.webp";
import landscape9_900 from "./landscape9-900.webp";
import landscape9 from "./landscape9.webp";

// Each landscape in widths 600, 900 and 1200 (the original) px for `srcSet` - the modal is at most
// 780 px wide, so phones and low-DPR screens download a smaller image
export const landscapes = [
  `${landscape1_600} 600w, ${landscape1_900} 900w, ${landscape1} 1200w`,
  `${landscape2_600} 600w, ${landscape2_900} 900w, ${landscape2} 1200w`,
  `${landscape3_600} 600w, ${landscape3_900} 900w, ${landscape3} 1200w`,
  `${landscape4_600} 600w, ${landscape4_900} 900w, ${landscape4} 1200w`,
  `${landscape5_600} 600w, ${landscape5_900} 900w, ${landscape5} 1200w`,
  `${landscape6_600} 600w, ${landscape6_900} 900w, ${landscape6} 1200w`,
  `${landscape7_600} 600w, ${landscape7_900} 900w, ${landscape7} 1200w`,
  `${landscape8_600} 600w, ${landscape8_900} 900w, ${landscape8} 1200w`,
  `${landscape9_600} 600w, ${landscape9_900} 900w, ${landscape9} 1200w`,
  `${landscape10_600} 600w, ${landscape10_900} 900w, ${landscape10} 1200w`,
  `${landscape11_600} 600w, ${landscape11_900} 900w, ${landscape11} 1200w`,
  `${landscape12_600} 600w, ${landscape12_900} 900w, ${landscape12} 1200w`,
];

// Rendered width of the image in the welcome modal - Mantine's "xl" modal (780 px),
// shrunk on small screens by the modal's 5vw horizontal offset on each side
export const landscapeSizes = "(max-width: 866px) 90vw, 780px";

export const getRandomLandscape = () =>
  landscapes[Math.floor(Math.random() * landscapes.length)];
